let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2YEqr")).then(() => parcelRequire('5C7tx'));